import { render, staticRenderFns } from "./layout-base.vue?vue&type=template&id=df25c1f0&"
import script from "./layout-base.vue?vue&type=script&lang=ts&"
export * from "./layout-base.vue?vue&type=script&lang=ts&"
import style0 from "./layout-base.vue?vue&type=style&index=0&id=df25c1f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports